/**
 * ECharts tree-shaken setup.
 *
 * Only registers the chart types, components, and renderer we actually use.
 * Import `echarts` from this module (not from 'echarts' directly) so the
 * bundle stays lean.
 */

import * as echarts from 'echarts/core';

import {
  BarChart,
  LineChart,
  MapChart,
  PieChart,
  RadarChart,
  ScatterChart,
  HeatmapChart,
  TreemapChart,
} from 'echarts/charts';

import {
  GeoComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  DataZoomComponent,
  VisualMapComponent,
  ToolboxComponent,
  MarkPointComponent,
  MarkLineComponent,
  RadarComponent,
} from 'echarts/components';

import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  BarChart,
  LineChart,
  MapChart,
  PieChart,
  RadarChart,
  ScatterChart,
  HeatmapChart,
  TreemapChart,
  GeoComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  DataZoomComponent,
  VisualMapComponent,
  ToolboxComponent,
  MarkPointComponent,
  MarkLineComponent,
  RadarComponent,
  CanvasRenderer,
]);

export { echarts };
